import styles from '../styles.module.scss';
import { TransactionResultProps } from '../../props';

import { useMemo } from 'react';
import skeleton from './styles.module.scss';

export default function TransactionResultDetailsSkeleton({
  minimal,
}: Pick<TransactionResultProps, 'minimal'>) {
  const Skeletons = useMemo(
    () =>
      Array.from({ length: minimal ? 3 : 6 }).map((_, index) => (
        <div
          className={styles.container__card}
          key={`transaciton-result-details-skeleton-${index}`}
        >
          <span
            className={`${styles.container__text} ${styles['container__text--secondary']}`}
          >
            <div className={skeleton.text} />
          </span>

          <span
            className={`${styles.container__text} ${styles['container__text--primary']}`}
          >
            <div className={skeleton.value} />
          </span>
        </div>
      )),
    [minimal],
  );

  return <div className={styles.container}>{Skeletons}</div>;
}
